import React from 'react';
import { useParams } from 'react-router-dom';

const UpdateAddress = () => {
     const { id } = useParams()
     return (
          <div>
               <h1>This is update {id} </h1>
          </div>
     );
};

export default UpdateAddress;